export default __webpack_public_path__ + "static/9-ce538c091499e0b001355fc75358431a.jpg";